export const STYLES_TYPE = 'styles';
